import React, {Component} from 'react';
import {Row, Col } from "reactstrap";
import {inject, observer} from "mobx-react/index";
import CardDetalhe from "../../../comum/components/CardDetalhe";
import AgendamentoContainerService from '../../../../services/AgendamentoContainerService';

@inject("store")
@observer
export default class DetalheAgendamento extends Component {
    constructor(props) {
        super(props);
        this.state = { UserCancel: "", DtCancel : "", AgendId : this.props.row.AgendId + '', Nome: ""}
        this.agendamentoController = this.props.controller;
    }

    formatarData(dataISO) {
        if (dataISO == '0001-01-01T00:00:00') return null;
        let d = new Date(dataISO);
        let dia = ('0' + d.getDate()).slice(-2);
        let mes = ('0' + (d.getMonth() + 1)).slice(-2);
        let ano = d.getFullYear();
        let horas = ('0' + d.getHours()).slice(-2);
        let minutos = ('0' + d.getMinutes()).slice(-2);      
        return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
    }
    
    base64ToPdfBlob = (base64) => {
        const byteCharacters = atob(base64);
        const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: 'application/pdf' });
    };

    async abrirDocumentoPDF () {
        try{
            const servico = new AgendamentoContainerService()
            const response = await servico.buscarDATPorAgenda(this.state.AgendId);
            if (response && response.data) {
                const base64 = response.data.ArquivoDAT;
                if (!base64) return;
                const blob = this.base64ToPdfBlob(base64, "application/pdf");
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
            }
        } catch(e){
            return;
        }
    }

    async componentDidMount(){    
        const  response = await this.agendamentoController.carregarDetalheCancel(this.props.row.AgendId)

        if (response != null) {
            this.setState({UserCancel: response.UserNomeCancel , DtCancel : this.formatarData(response.DtCancel), Nome: response.Nome})    
        }  
    }

    render() {
        
        return (
            
            <Col xs={12} className="container-card-detalhe">
                <div className="pb-3 pt-3">
                <h4>{this.props.titulo}</h4>
                    <Row className="m-0 no-gutters">
                    {
                        <Col sm={4}>
                            <CardDetalhe titulo={"Número ticket"}
                                     desc={this.state.AgendId}
                                     pt="pt-2"
                                     pb="pb-2"
                        />
                        </Col>
                    }
                   
                    { this.props.row.CodStatus == "C" && 
                    <Col sm={4}>
                        
                            <CardDetalhe titulo={"Usuário do cancelamento"}
                                         desc={this.state.UserCancel + " - " + this.state.Nome}
                                         pt="pt-2"
                                         pb="pb-2"
                            />
                        </Col>
                    }   
                    { this.props.row.CodStatus == "C" &&
                        <Col sm={4}>
                        <CardDetalhe titulo={"Data do Cancelamento"}
                                     desc={ this.state.DtCancel}
                                     pt="pt-2"
                                     pb="pb-2"
                        />
                    </Col>
                    }
                    
                    { this.props.row.CodStatus == "CI" && 
                    <Col sm={4}>
                        
                            <CardDetalhe titulo={"Usuário do cancelamento"}
                                         desc={"Cancelado automaticamente pelo sistema."}
                                         pt="pt-2"
                                         pb="pb-2"
                            />
                        </Col>
                    }  
                    { this.props.row.Dat != 0 && 
                        <Col sm={4}>
                            <CardDetalhe 
                                titulo={"DAT"} 
                                desc={
                                    <span 
                                        style={{ cursor: 'pointer', textDecoration: 'none', color: '#inherit' }}
                                        onClick={async () => await this.abrirDocumentoPDF()}
                                    >
                                        📥Visualizar documento
                                    </span>
                                }
                                pt="pt-2"
                                pb="pb-2"
                            />
                        </Col>
                    }                   
                    </Row>
                </div>
            </Col>)
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-visualizar/components/DetalheAgendamento.js